import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { SECTION_NAMES } from '@constants/sectionNames';
import { HeadContent, Loading } from '@fourthwall/components';
import { isProduction } from '@fourthwall/utils';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { routing } from '@utils/routing';
import React, { useState } from 'react';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import { usePackiyo } from './hooks/usePackiyo';
export const AppsPackiyo = () => {
    const { connectBar, isLoading, hmac } = usePackiyo();
    const { currentShop } = useCurrentShop();
    if (!connectBar || !currentShop) {
        return React.createElement(Loading, { isLoading: isLoading });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Packiyo" }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: "Packiyo", topContent: React.createElement(DashboardBackButton, { label: SECTION_NAMES.apps, to: routing.apps.self }), bottomContent: React.createElement("p", null, "Connect your Fourthwall account to Packiyo to sync orders and inventory.") },
                React.createElement(Loading, { isLoading: isLoading },
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
                        React.createElement(ConnectBar, { ...connectBar }),
                        hmac ? (React.createElement(SettingsIframe, { hmac: hmac, shopId: currentShop?.id })) : (React.createElement("p", null, "Something is wrong with this app's configuration."))))))));
};
const SettingsIframe = ({ hmac, shopId, }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const url = isProduction()
        ? 'https://packiyo.fourthwall.app/settings'
        : 'https://packiyo-staging.fourthwall.app/settings';
    return (React.createElement(React.Fragment, null,
        !isLoaded && React.createElement(Loading, { isLoading: true }),
        React.createElement("iframe", { style: { display: isLoaded ? 'block' : 'none', marginTop: '50px', minHeight: '800px' }, src: `${url}?hmac=${encodeURIComponent(hmac.signature)}&timestamp=${encodeURIComponent(hmac.timestamp)}&shop_id=${encodeURIComponent(shopId)}`, onLoad: () => setIsLoaded(true), width: "100%" })));
};
